// src/hooks/useData.js
// Shared Firestore data context - one-time fetch (data almost never changes)
import { useState, useEffect, createContext, useContext } from "react";
import { fetchCategories } from "../firebase/services";

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const cats = await fetchCategories();
      if (cancelled) return;
      setCategories(cats.filter((c) => c.active));
      setReady(true);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <DataContext.Provider value={{ categories, ready }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
